// SetningsMinne/TrialSentences.js
import React, { Component } from 'react';
import strings from 'strings';
import { updateStepData } from 'api';
import listen from 'assets/listen.png';

// Audio asset packs you provide (Howler or HTMLAudio wrappers).
// Each should index steps: 0,1,2,... and have .play(), .pause()/stop(), .on('end', cb)
import {
  getTrialAudioPack,
  getTrialFeedbackPack,
} from './assets';

import './styles.scss';

class TrialSentences extends Component {
  constructor(props) {
    super(props);
    const langCode = strings.getLanguage();
     this.assets = getTrialAudioPack(
      langCode,
      props.ageGroup,
      props.testKeyType
    );
    this.answers = getTrialFeedbackPack(
      langCode,
      props.ageGroup,
      props.testKeyType
    );


  }

  componentDidMount() {
    this.initializeAudio();
  }
  componentWillUnmount() {
    this.stopAll();
    clearTimeout(this.timeout);
  }

 componentDidUpdate(prevProps) {
  if (prevProps.currentStep !== this.props.currentStep) {
    this.startNewTask(this.props.currentStep);
  }
  const prevSD = prevProps.stepData || {};
  const nextSD = this.props.stepData || {};
  if (nextSD.answered && !prevSD.answered) {
    this.playFeedback(this.props.currentStep, nextSD.correct);
  }
}

  initializeAudio = () => {
    Object.values(this.assets).forEach((a) => a.load && a.load());
    Object.values(this.answers).forEach((a) => a.load && a.load());
    this.timeout = setTimeout(() => this.startNewTask(this.props.currentStep), 600);
  };

startNewTask = (idx) => {
  this.stopAll();
  const sound = this.assets[idx];
  if (!sound) {
    console.warn('Missing audio for trial step', idx);
    return;
  }
  sound.play();
};

  playFeedback = (taskIndex, isCorrect) => {
    const n = (taskIndex || 0) + 1; 
    const key = `${isCorrect ? 'correct' : 'incorrect'}${n}`;
    const clip = this.answers[key];

    if (!clip) {
     
      const generic = this.answers[isCorrect ? 'correct' : 'incorrect'];
      if (!generic) {
       
        setTimeout(() => updateStepData({ feedbackDone: true }), 800);
        return;
      }
      generic.on('end', () => setTimeout(() => updateStepData({ feedbackDone: true }), 400));
      generic.play();
      return;
    }

  clip.once('end', () => setTimeout(() => updateStepData({ feedbackDone: true }), 400));   
  clip.play();
  };

  stopAll = () => {
    const stop = (s) => {
      if (s.stop) s.stop();
      else if (s.pause) s.pause();
    };
    Object.values(this.assets).forEach(stop);
    Object.values(this.answers).forEach(stop);
  };

  render() {
    return (
      <div className="SetningsMinne">
        <img className="listen-image" src={listen} alt="" />
        <p>{strings.sm_trial_listen_repeat}</p>
      </div>
    );
  }
}

export default TrialSentences;
